import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {SubscriptionService} from "../services/subscription-service";
import {useGlobalSnackbarStore} from "../stores/global-snackbar-store";

export const useAdminSubscriptions = () => {
    const {error, success} = useGlobalSnackbarStore((state) => state);
    const queryClient = useQueryClient();

    const queryInfo = useQuery({
        queryKey: ['subscriptions'],
        queryFn: async () => await SubscriptionService.list(),
    });

    const {mutateAsync: subscribe, isPending: isSubscribePending} = useMutation({
        mutationFn: async ({breederId, duration}: {breederId: string, duration: number}) => await SubscriptionService.subscribe(breederId, duration),
        onSuccess: () => success('Subscription angelegt!'),
        onError: () => error('Fehler beim Anlegen der Subscription!'),
        onSettled: async () => await Promise.all([
            queryClient.invalidateQueries({queryKey: ['subscription']}),
            queryClient.invalidateQueries({queryKey: ['subscriptions']}),
        ]),
    });

    const {mutateAsync: unsubscribe, isPending: isUnsubscribePending} = useMutation({
        mutationFn: async (breederId: string) => await SubscriptionService.unsubscribe(breederId),
        onSuccess: () => success('Subscription entfernt!'),
        onError: () => error('Fehler beim Entfernen der Subscription!'),
        onSettled: async () => await Promise.all([
            queryClient.invalidateQueries({queryKey: ['subscription']}),
            queryClient.invalidateQueries({queryKey: ['subscriptions']}),
        ]),
    });

    return {
        ...queryInfo,
        get subscriptions() { return queryInfo.data; },
        subscribe,
        isSubscribePending,
        unsubscribe,
        isUnsubscribePending,
    };
};